export const ApiQueryKey = {
	products: 'products',
	productTypes: 'product-types',
	componentCategories: 'component-categories',
	components: 'components',
	attributes: 'attributes',
	attributeValues: 'attribute-values',

	admins: 'admins',

	roles: 'roles',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
